import { render, staticRenderFns } from "./ProductPageV2.vue?vue&type=template&id=55f40220&"
import script from "./ProductPageV2.vue?vue&type=script&lang=js&"
export * from "./ProductPageV2.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports